import React, { Suspense } from 'react'
import MomentClient from '@/library/utils/formatters/MomentClient'

export default function MomentFormatter(props) {
  const { date, className = "text-sm text-gray-600" } = props
  return (
    <>
      <Suspense>
        <MomentClient date={date} className={className} />
      </Suspense>
    </>
  )
}
